import Paginate from './paginate'

const plugin = {
    install: Vue => {
        Vue.component(Paginate.name, Paginate)
    }
}

Paginate.install = plugin.install

export default Paginate



// WEBPACK FOOTER //
// ./src/components/paginate/index.js